import { e as error } from "../../../../../../chunks/index2.js";
import * as path from "node:path";
import { i as isDevelopment } from "../../../../../../chunks/utils.js";
import * as fs from "node:fs";
import { Readable } from "node:stream";
import * as os from "node:os";
const modules = /* @__PURE__ */ Object.assign({ "/src/lib/client/assets/alex.png": () => import("../../../../../../chunks/alex.js"), "/src/lib/client/assets/error.png": () => import("../../../../../../chunks/error.js"), "/src/lib/client/assets/flexy-happy-young-man-celebrating-something.svg": () => import("../../../../../../chunks/flexy-happy-young-man-celebrating-something.js"), "/src/lib/client/assets/forms-pinkish-blur.png": () => import("../../../../../../chunks/forms-pinkish-blur.js"), "/src/lib/client/assets/glimmr-product-diagram.png": () => import("../../../../../../chunks/glimmr-product-diagram.js"), "/src/lib/client/assets/happy-customer.png": () => import("../../../../../../chunks/happy-customer.js"), "/src/lib/client/assets/icon.ico": () => import("../../../../../../chunks/icon.js"), "/src/lib/client/assets/icon.png": () => import("../../../../../../chunks/icon2.js"), "/src/lib/client/assets/icon.svg": () => import("../../../../../../chunks/icon3.js"), "/src/lib/client/assets/jordan.png": () => import("../../../../../../chunks/jordan.js"), "/src/lib/client/assets/mia.png": () => import("../../../../../../chunks/mia.js"), "/src/lib/client/assets/riley.png": () => import("../../../../../../chunks/riley.js") });
const GET = async ({ params }) => {
  const filename = params.filename;
  const modulePath = Object.keys(modules).find(
    (modulePath2) => path.basename(modulePath2) === filename
  );
  if (!modulePath) {
    return error(404, {
      message: "File not found"
    });
  }
  const module = await modules[modulePath]();
  const basePath = isDevelopment ? path.join(import.meta.url, "..", "..", "..", "..", "..") : path.join(import.meta.url, "..", "..", "..", "client");
  const fileUrl = new URL(path.join(basePath, module.default));
  const filePath = path.normalize(fileUrl.pathname);
  const sanitizedFilePath = os.platform() === "win32" ? filePath.replace("\\", "") : filePath;
  const stream = fs.createReadStream(sanitizedFilePath);
  const webStream = Readable.toWeb(stream);
  return new Response(webStream);
};
export {
  GET
};
